import React from "react";
import ContentListGrid from "../components/ContentListGrid";
import PublicPageSettings from "../components/PublicPageSettings";
import LeadershipBodySettings from "../components/LeadershipBodySettings";
import { COLLECTIONS } from "../utils/cmsSchema";

// CMS home for /executive-leadership. Layered top-down:
//   1. PublicPageSettings — hero + page-level SEO for the public page.
//   2. ContentListGrid — the actual list of leader profiles, with
//      create/publish/delete plumbing shared with blogs/news/careers.
//
// Nothing about-us-specific here — the About Us CMS entry adds a
// "Manage Executive Leadership" link that points into this page, and
// the top nav has a dedicated Leadership tab.
export default function LeadershipList() {
  return (
    <div>
      <PublicPageSettings
        collectionKey="executive-leadership"
        publicPath="/executive-leadership"
        defaultHeading="Executive Leadership"
        defaultSubheading="Meet the team behind Leechiu Property Consultants — the people leading the country's largest independent real estate advisory firm."
      />
      <LeadershipBodySettings />
      <ContentListGrid
        schema={COLLECTIONS.leaders}
        title="Leader Profiles"
        subtitle="Individual profile pages appear at /executive-leadership/<slug>. Order them via the Sort Order field on each profile."
        newRoute="/cms/leadership/new"
        metaFor={(d) => d.position || ""}
      />
    </div>
  );
}
